import { ROLES } from '../types/permissions';

export const hasPermission = (userRole, userPermissions, requiredPermission, appId) => {
  // Admins have all permissions
  if (userRole === ROLES.ADMIN) {
    return true;
  }

  // Check if user has the required permission for the specific app
  const appPermissions = userPermissions[appId] || [];
  return appPermissions.includes(requiredPermission);
};

export const canAccessUsers = (userRole) => {
  return userRole === ROLES.ADMIN;
};
